import React from 'react'
import Hero from '../../components/Hero/Hero';
import heroImage from '../../assets/images/Media/Media.jpg';
import Top from '../../components/Top Section/Top/Top';
import Accordion from '../../components/Accordion/Accordion';
import anshika_pod from '../../assets/images/Media/anshika_pod.jpeg'
import ceo_ama from '../../assets/images/Media/AMA-CEO.png'

const Media = () => {
    const items = [
        {
             title: 'Media 1: Digital Transformation Through Technology',
             content:[
                {
                    heading:"Overview",
                    text:"In today's fast-paced digital landscape, businesses need to adapt quickly to stay competitive. TechTorch Solutions has been at the forefront of helping organizations embrace digital transformation through innovative technology solutions and strategic guidance."
                },
                {
                    heading:"Key Insights",
                    text:"Our media coverage highlights how companies across various industries have successfully transformed their operations using cutting-edge technology. From cloud migration to AI integration, we showcase real-world examples of how digital solutions drive business growth and operational excellence."
                },
               {
                 heading:"Impact",
                text:"These success stories demonstrate the tangible benefits of embracing technological innovation, including improved efficiency, cost savings, and enhanced customer experiences."
               }
            ]
         },
         {
            title: 'Media 2: Industry Trends & Expert Commentary',
            content:[
               {
                   heading:"Overview",
                   text:"Stay informed about the latest trends shaping the technology industry. TechTorch Solutions provides expert insights and commentary on emerging technologies, market dynamics, and industry best practices."
               },
               {
                   heading:"Featured Topics",
                   text:"Our media presence covers critical topics including artificial intelligence, cloud computing, cybersecurity, and digital innovation. Our thought leaders share their perspectives on how these technologies are reshaping business landscapes."
               },
              {
                heading:"Value Proposition",
               text:"By following our media updates, businesses gain valuable insights that help them make informed decisions about their technology investments and strategic initiatives."
              }
           ]
        },
        {
            title: 'Media 3: Press Releases & Company Updates',
            content:[
               {
                   heading:"Overview",
                   text:"Stay updated with the latest news from TechTorch Solutions. Our press releases cover new product launches, strategic partnerships, company milestones, and industry recognitions."
               },
               {
                   heading:"Recent Announcements",
                   text:"We regularly announce new solutions, partnerships with leading technology providers, and expansions into new markets. These updates reflect our commitment to delivering innovative solutions and maintaining our position as a trusted technology partner."
               },
              {
                heading:"Stay Connected",
               text:"Our media channels provide comprehensive information about company developments, helping stakeholders stay informed about our latest initiatives and achievements."
              }
           ]
        },
        {
            title: 'Media 4: Customer Testimonials & Success Stories',
            content:[
               {
                   heading:"Overview",
                   text:"Hear directly from our satisfied clients about their experiences working with TechTorch Solutions. Customer testimonials provide authentic insights into how our solutions have transformed their businesses."
               },
               {
                   heading:"Featured Stories",
                   text:"Our media library includes in-depth interviews with clients who have implemented our solutions. These stories highlight the challenges they faced, the solutions we provided, and the measurable results they achieved."
               },
              {
                heading:"Why It Matters",
               text:"Customer success stories serve as powerful validation of our expertise and commitment to delivering results. They demonstrate our ability to understand client needs and provide tailored solutions that drive real business impact."
              }
           ]
        }

      ];

  return (
    <>
         {/* start hero section  */}
            <Hero
                image={heroImage}
                image_name="Media"
                page_name="Media"
                heading="Stay Informed: Latest News & Insights"
            />
      {/* end hero section  */}

      {/* Start Podcast Section  */}
      <div className="container py-lg-5 py-md-4 py-3">
        <div className="row">
          <div className="col-lg-6 mx-auto">
            <div className="card shadow-sm border-0 h-100">
              <div className="card-body p-lg-4 p-3">
                <div className="d-flex align-items-center mb-3">
                  <i className="bi bi-mic-fill text-danger fs-4 me-2"></i>
                  <h5 className="card-title mb-0 fw-bold">HR Team Latest Podcast</h5>
                </div>
                <div className="mb-3">
                  <img src={anshika_pod} alt="Anshika Podcast" className="img-fluid rounded mb-3" />
                </div>
                <p className="card-text text-muted mb-3">
                  Listen to our HR team discuss the latest insights on workplace culture, employee development, and industry trends.
                </p>
                <a href="https://youtu.be/gZO3T0dvRcA?si=akqJ6i-ytSbeWkNp" target="_blank" rel="noopener noreferrer" className="btn btn-danger">Listen Now</a>
              </div>
            </div>
          </div>
           <div className="col-lg-6 mx-auto">
            <div className="card shadow-sm border-0 h-100">
              <div className="card-body p-lg-4 p-3">
                <div className="d-flex align-items-center mb-3">
                  <i className="bi bi-mic-fill text-danger fs-4 me-2"></i>
                  <h5 className="card-title mb-0 fw-bold">AMA Session With CEO</h5>
                </div>
                <div className="mb-3">
                  <img src={ceo_ama} alt="CEO AMA" className="img-fluid rounded mb-3" />
                </div>
                <p className="card-text text-muted mb-3">
                  Listen to our CEO on code to intelligence Powered by Nadcab Lab, where he shares his vision for the company, answers questions from guests, and discusses the future of technology in business.
                </p>
                <a href="https://www.linkedin.com/events/7483832519939985408/" target="_blank" rel="noopener noreferrer" className="btn btn-danger">Listen Now</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Podcast Section  */}

      {/* Start Top Section  */}
      <div className="container py-lg-5 py-md-4 py-3">
      <Top
        heading="Industry Insights, Expert Commentary, and Success Stories"
        content="At TechTorch Solutions, we believe in sharing knowledge and insights that help businesses make informed decisions. Explore our media coverage featuring expert commentary, industry trends, client success stories, and the latest company updates."
      />
      </div>
      {/* End Top Section  */}

      {/* Start Accordion Section  */}
      <div className="container py-3">
        <div className="row">
            <h1 className='mb-lg-4 mb-3 fw-bold text-dark-beetroot'>Your Source for Technology News and Business Insights</h1>
        </div>
        <div className="row">
            <div className="col-lg-8">
            <Accordion items={items} />
            </div>
        </div>
      </div>
      {/* End Accordion Section  */}
    </>
  )
}

export default Media
